import { useMemo } from "react"
import cn from "classnames"

import { SESSION_TYPE } from "modules/Booking/common/constants"
import { Img } from "ui-kit/components-branded/index"
import { parsePhoneNumber } from "utils/phone-number"

interface SessionDetailsProps {
    sessionType: SESSION_TYPE
    phone: string
    email: string
}

export function SessionDetails({ sessionType, phone, email }: SessionDetailsProps) {
    const content = useMemo(() => {
        if (sessionType === SESSION_TYPE.DEFAULT) {
            return {
                headerImgSrc: "mailbox-emoji.png",
                headerImgClass: "",
                headerTitle: "Отправили все детали сессии:",
            }
        }
        if (sessionType === SESSION_TYPE.TIME_REQUEST) {
            return {
                headerImgSrc: "hourglass_flowing_sand.png",
                headerImgClass: "booking__small-emoji--is-time-request",
                headerTitle: "Когда психолог подтвердит время, мы отправим вам все детали сессии:",
            }
        }
    }, [sessionType])

    return (
        <div className="after-payment__session-details">
            <div className="after-payment__session-details__text">
                <Img
                    className={cn("booking__small-emoji", content?.headerImgClass)}
                    src={content?.headerImgSrc}
                />{" "}
                {content?.headerTitle}
            </div>
            <div className="after-payment__session-details__text">
                <span className="after-payment__session-details__bullet">•</span> в смс на номер{" "}
                {parsePhoneNumber(phone).groupedFormat}
            </div>
            <div className="after-payment__session-details__text">
                <span className="after-payment__session-details__bullet">•</span> на почту {email}
            </div>
            {sessionType === SESSION_TYPE.TIME_REQUEST && (
                <>
                    Если подтверждения не&nbsp;будет в&nbsp;течение 24&nbsp;часов, мы&nbsp;сообщим
                    вам и&nbsp;вернем деньги полностью.
                </>
            )}
        </div>
    )
}
